import React from 'react'
import { useHover } from '../../hooks/useHover'

const CleverAlphaButton = ({ children, onClick }) => {
    const { isHover, onMouseEnter, onMouseLeave } = useHover();
    const buttonStyle = {
        padding: '8px 40px',
        backgroundColor: isHover ? '#CCC' : '#EFEFEF',
        border: '1px solid black',
        fontWeight: 'bold',
        cursor: 'pointer'
    }
    return (
        <button style={buttonStyle} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} onClick={onClick}>{children}</button>
    )
}

export default CleverAlphaButton;
